module.exports = __webpack_public_path__ + "static/media/design_services.6fcb8614.jpg";